export default __webpack_public_path__ + "static/media/cloudBlack.ab8b8dd5.png";